
















































































































































































import {Component, Mixins, Watch} from 'vue-property-decorator';
import BaseLayout from '@/layouts/BaseLayout.vue';
import Breadcrumb from '@/models/Breadcrumb';
import {ResponsiveMixin} from '@/mixins/ResponsiveMixin';
import {fetchImportedSessions} from '@/repositories/api/ImportedSessionApi';
import ItemModel from '@/models/ItemModel';
import Overlay from '@/models/Overlay';
import Alert from '@/models/Alert';

@Component({
  components: {
    BaseLayout,
  }
})
export default class BaseListView extends Mixins(ResponsiveMixin) {
  protected loading = false;
  protected overlay = new Overlay();
  protected alert = new Alert();

  protected fetchItems: Function = fetchImportedSessions;

  protected selected: any[] = [];
  protected dense = true;
  protected showSelect = true;
  protected sortBy = 'id';
  protected classes = 'elevation-1';
  protected itemLabel = 'Session';
  protected viewLabel = 'Liste';
  protected apostrophe = true;
  protected masculin = false;
  protected title = this.itemLabel;
  protected newItemLabel: string | undefined;
  protected selectedDeleteActionLabel: string | undefined;
  protected loadButtonLabel: string | undefined;

  protected deleteDialogTitle: string | undefined;
  protected deleteDialogDescription: string | undefined;
  protected deleteDialogCancelButtonLabel = 'Annuler';
  protected deleteDialogCancelButtonDelete = 'Supprimer';

  protected selectedDeleteDialogTitle: string | undefined;
  protected selectedDeleteDialogDescription: string | undefined;
  protected selectedDeleteDialogCancelButtonLabel = 'Annuler';
  protected selectedDeleteDialogCancelButtonDelete = 'Supprimer';

  protected addDialogTitle: string | undefined;
  protected editDialogTitle: string | undefined;
  protected saveDialogDescription: string | undefined;
  protected saveDialogCancelButtonLabel = 'Annuler';
  protected saveDialogCancelButtonAdd = 'Ajouter';
  protected saveDialogCancelButtonEdit = 'Modifier';

  protected breadcrumbs: Breadcrumb[] | undefined;

  protected dialog = false;
  protected deleteDialog = false;
  protected selectedDeleteDialog = false;
  protected itemModels: ItemModel[] = [];
  protected headers = [];
  protected items: any[] = [];
  protected editedIndex = -1;
  protected deleteIndex = -1;
  protected selectedDeleteIndex = -1;
  protected editedItem: any = {};

  protected defaultItem = null;

  @Watch('itemLabel') onItemLabelChanged(value: string) {
    this.init();
  }

  @Watch('dialog') onDialogChanged(val: boolean) {
    val || this.close();
  }

  init() {
    this.newItemLabel = this.newItemLabel ? this.newItemLabel : 'Nouvel ' + this.itemLabel.toLocaleLowerCase();
    this.selectedDeleteActionLabel = this.selectedDeleteActionLabel ? this.selectedDeleteActionLabel : 'Supprimer les ' + this.itemLabel.toLocaleLowerCase() + 's';
    this.loadButtonLabel = 'Recharger';

    this.deleteDialogTitle = this.deleteDialogTitle ? this.deleteDialogTitle : 'Suppression de ' + this.itemLabel.toLowerCase();
    this.deleteDialogDescription = this.deleteDialogDescription ? this.deleteDialogDescription : this.getLe(true) + this.getItemLabel() + 'sera définitivement supprimée avec toute ses dépendances';

    this.selectedDeleteDialogTitle = this.selectedDeleteDialogTitle ? this.selectedDeleteDialogTitle : 'Suppression de ' + this.itemLabel.toLowerCase() + '(s)';
    this.selectedDeleteDialogDescription = this.selectedDeleteDialogDescription ? this.selectedDeleteDialogDescription : 'La (les) ' + 'session(s) sélectionnée(s) sera(ont) supprimée(s) avec toutes leurs dépendances de la base de données';

    this.addDialogTitle = this.addDialogTitle ? this.addDialogTitle : (this.masculin ? (this.apostrophe ? 'Nouvel' : 'Nouveau ') : 'Nouvelle ') + this.getItemLabel(true);
    this.editDialogTitle = this.editDialogTitle ? this.editDialogTitle : 'Modifier ' + this.getItemLabel(true);
    this.saveDialogDescription = this.saveDialogDescription ? this.saveDialogDescription : 'Modifier ' + this.getItemLabel(true);

    this.breadcrumbs = this.breadcrumbs && this.itemLabel ? this.breadcrumbs : [
      {
        text: 'Accueil',
        disabled: false,
        icon: '',
        href: '/',
      },
      {
        text: this.itemLabel + 's',
        disabled: false,
        icon: '',
        href: '/sessions',
      },
      {
        text: this.viewLabel,
        disabled: true,
        icon: '',
        href: '/sessions/importées',
      },
    ];
  }

  getLe(upperCase = false) {
    if (!this.apostrophe || !this.masculin) {
      return '';
    }

    let le = this.apostrophe ? 'l\'' : (this.masculin ? 'le ' : 'la ');

    return upperCase ? le.toUpperCase() : le.toLocaleLowerCase();
  }

  getItemLabel(upperCase = false) {
    if (!this.itemLabel || !this.masculin) {
      return '';
    }

    return upperCase ? this.itemLabel.toUpperCase() : this.itemLabel.toLocaleLowerCase();
  }

  get getFormTitle(): string {
    if (!this.editedIndex || !this.addDialogTitle || !this.editDialogTitle) {
      return '';
    }

    return this.editedIndex === -1 ? this.addDialogTitle : this.editDialogTitle;
  }

  get getFormSaveButtonLabel(): string {
    if (!this.editedIndex || !this.saveDialogCancelButtonAdd || !this.saveDialogCancelButtonEdit) {
      return '';
    }

    return this.editedIndex === -1 ? this.saveDialogCancelButtonAdd : this.saveDialogCancelButtonEdit;
  }

  editItem(item: any) {
    this.editedIndex = this.items.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.dialog = true;
  }

  deleteItem(item: any) {
    this.deleteIndex = this.items.indexOf(item);
    this.deleteDialog = true;
    // confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1);

    this.deleteDialog = true;
  }

  selectedDeleteItem(item: any) {
    this.selectedDeleteIndex = this.items.indexOf(item);
    this.selectedDeleteDialog = true;
    // confirm('Are you sure you want to selectedDelete this item?') && this.items.splice(index, 1);

    this.selectedDeleteDialog = true;
  }

  processDeleteItem() {
    const item = this.items[this.deleteIndex];

    // confirm('Are you sure you want to delete this item?') && this.items.splice(index, 1);

    this.deleteIndex = -1;
    this.deleteDialog = false;
  }


  processSelectedDeleteItem() {
    const item = this.items[this.selectedDeleteIndex];

    // confirm('Are you sure you want to selectedDelete this item?') && this.items.splice(index, 1);

    this.selectedDeleteIndex = -1;
    this.selectedDeleteDialog = false;
  }

  closeDelete() {
    this.deleteDialog = false;
    setTimeout(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    }, 300);
  }

  closeSelectedDelete() {
    this.selectedDeleteDialog = false;
    setTimeout(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    }, 300);
  }

  close() {
    this.dialog = false;
    setTimeout(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    }, 300);
  }

  save() {
    if (this.editedIndex > -1) {
      Object.assign(this.items[this.editedIndex], this.editedItem);
    } else {
      this.items.push(this.editedItem);
    }
    this.close();
  }

  newItemAction(){
    this.dialog = true;
  }

  selectedDeleteAction(){
    this.selectedDeleteDialog = true;
  }

  async loadItems() {
    this.loading = true;

    const response = await this.fetchItems();
    if (response.error == 'success') {
      this.itemModels = response.model;
      this.items = response.data;
    }

    this.loading = false;
  }

  created() {
    this.init();
  }

  mounted() {
    this.loading = true;
    this.loadItems();
    this.loading = true;
  }
}
